import * as Yup from "yup";

export const formValidationSchema = Yup.object().shape({
  tgl_nilai_perolehan_aset: Yup.string().required("Masukan tanggal"),
  nomor_coa_debet: Yup.string().required("Masukan COA Debet"),
  nomor_coa_kredit: Yup.string().required("Masukan COA Kredit"),
});
